// extracted by mini-css-extract-plugin
module.exports = {"parent":"Counter_parent__PTG5M","root":"Counter_root__BCDLy","circle":"Counter_circle__RN4Bo","primary":"Counter_primary__8EXWe","secondary":"Counter_secondary__qMuEO"};